import { useState } from 'react'

import { Box, TextField, Typography } from '@material-ui/core'
import { Autocomplete } from '@material-ui/lab'

import api from 'common/api'

const OTHER_TEXT = "I don't see my school"
const otherSchoolSelection: CollegeOption = {
  city: '',
  country: '',
  name: OTHER_TEXT,
  scid: 0,
  state: '',
  tokens: [OTHER_TEXT, '', ''],
  value: '',
}

export type CollegeOption = {
  city: string
  country: string
  name: string
  scid: number
  state: string
  tokens: string[]
  value: string
}

type CollegeAutocompleteProps = {
  onSelect: (school: CollegeOption | null) => void
  onBlur?: React.FocusEventHandler
  name?: string
  error?: boolean
  helperText?: React.ReactNode
}

const CollegeAutocomplete = ({ onSelect, onBlur, name, error, helperText }: CollegeAutocompleteProps) => {
  const [open, setOpen] = useState(false)
  const [options, setOptions] = useState<CollegeOption[]>([])

  const handleOpen = () => {
    setOpen(!open)
  }

  const onSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    const searchName = e.target.value
    if (!searchName) {
      return setOptions([])
    }
    return api.get<CollegeOption[]>(`/api/search/college/${searchName}`).then((colleges) => {
      const options = [...colleges, otherSchoolSelection]
      setOptions(options)
      setOpen(true)
    })
  }

  const renderOptions = (option: CollegeOption) => {
    const hasLocation = option.city && option.state
    return (
      <Box>
        <Typography>{option.name}</Typography>
        {hasLocation && (
          <Typography
            variant="caption"
            color="textSecondary"
          >{`${option.city}, ${option.state}`}</Typography>
        )}
      </Box>
    )
  }

  const handleDefaultOption = (options: CollegeOption[]) => {
    return options
  }

  const handleChange = (_e: any, val: string | CollegeOption | null) => {
    if (!val) {
      onSelect(null)
      return
    }
    const pickedSchool = { ...(val as CollegeOption) }
    onSelect(pickedSchool)
  }

  return (
    <div className="college-search-comp">
      <Autocomplete
        freeSolo
        open={open}
        onClose={handleOpen}
        getOptionLabel={(option) => option.name}
        renderOption={renderOptions}
        options={options}
        onChange={handleChange}
        filterOptions={handleDefaultOption}
        renderInput={(params) => (
          <TextField
            {...params}
            onChange={onSearch}
            onBlur={onBlur}
            name={name}
            error={error}
            helperText={helperText}
            label="Select Your College"
            variant="outlined"
            InputProps={{
              id: 'select-college-autocomplete',
              ...params.InputProps,
            }}
          />
        )}
      />
    </div>
  )
}

export default CollegeAutocomplete
